import React from "react";
import { PaymentType, VehicleCondition } from "@wayke-se/ecom";
import { accessoryTotalPrice, formatPrice } from "../utils/helpers";
import { getLoanDetails, getLoanInformation, getPaymentMethodTitle, } from "../utils/payment";
import { getRetailerInformation } from "../utils/retailer";
import { getVehicleDescription, getVehicleTitle } from "../utils/trade-in-car";
import DeliveryInformation from "./delivery-information";
import ProductItem from "./product-item";
export default (props) => {
    const products = [];
    const hasLoan = props.data.payment.paymentType &&
        props.data.payment.paymentType === PaymentType.Loan;
    const hasInsurance = props.data.insurance.hasAddedInsurance;
    const hasTradeIn = props.data.tradeInCar.wantsToDefineTradeIn &&
        props.data.tradeInCar.hasProvidedTradeInInfo &&
        props.data.tradeInCar.hasTradeInCar &&
        props.data.tradeInCar.registrationNumber &&
        props.vehicleLookup !== null;
    const hasAccessories = props.data.chosenAccessories.ids.length > 0;
    if (hasLoan) {
        const loanDetails = getLoanDetails(props.orderOptions, props.paymentLookup);
        const loanInformation = getLoanInformation(props.orderOptions);
        const loanPrice = loanDetails ? loanDetails.getCosts().monthlyCost : "";
        products.push({
            title: getPaymentMethodTitle(PaymentType.Loan),
            description: loanInformation.name,
            price: loanPrice,
            unit: loanInformation.unit,
            addons: [],
        });
    }
    if (hasInsurance) {
        const insuranceOption = props.insuranceOptions.getInsuranceOption();
        const addons = insuranceOption.addons
            .filter((a) => props.data.insurance.addons.includes(a.name))
            .map((a) => ({
            title: a.title,
            price: a.monthlyPrice,
            unit: "kr/mån",
        }));
        products.push({
            addons,
            title: "Försäkring",
            description: `${insuranceOption.brand.name} - ${insuranceOption.name}`,
            price: insuranceOption.price,
            unit: insuranceOption.unit,
        });
    }
    if (hasAccessories) {
        const accessories = props.orderOptions.getAccessories();
        const chosenAccessories = accessories.filter((a) => props.data.chosenAccessories.ids.includes(a.id));
        const addons = chosenAccessories.map((a) => {
            const totalPrice = accessoryTotalPrice(a);
            return {
                title: a.name,
                price: totalPrice,
                unit: "kr",
            };
        });
        const accessoriesSumPrice = chosenAccessories.reduce((sum, accessory) => sum + accessoryTotalPrice(accessory), 0);
        products.push({
            addons,
            title: "Tillbehör",
            price: accessoriesSumPrice,
            unit: "kr",
        });
    }
    const items = products.map((p, index) => (React.createElement(ProductItem, Object.assign({ key: index }, p))));
    let tradeInItem;
    if (hasTradeIn) {
        const vehicleInformation = props.vehicleLookup.getVehicle();
        const tradeInTitle = `${getVehicleTitle(vehicleInformation)} ${getVehicleDescription(vehicleInformation)}`;
        const valuation = !!vehicleInformation.valuation
            ? formatPrice(Math.round(vehicleInformation.valuation / 100) * 100)
            : null;
        let condition = "mycket bra skick";
        switch (props.data.tradeInCar.condition) {
            case VehicleCondition.Good:
                condition = "bra skick";
                break;
            case VehicleCondition.Ok:
                condition = "helt okej skick";
                break;
        }
        tradeInItem = (React.createElement("div", { className: "repeat-m" },
            React.createElement("div", { "data-ecom-productcard": "" },
                React.createElement("div", { className: "product-card-content-section" },
                    React.createElement("div", { className: "product-card-content" },
                        React.createElement("div", { className: "product-card-title" },
                            React.createElement("div", { className: "product-card-heading" },
                                "Inbytesbil i ",
                                condition)),
                        React.createElement("ul", { className: "product-card-usp-list" },
                            React.createElement("li", { className: "product-card-usp-item" }, props.data.tradeInCar.registrationNumber),
                            React.createElement("li", { className: "product-card-usp-item" }, tradeInTitle)),
                        valuation && (React.createElement("div", { className: "m-t-mini" },
                            "Uppskattat v\u00E4rde: ",
                            valuation,
                            " kr")))))));
    }
    const formattedPrice = formatPrice(props.vehicle.price);
    const retailerInformation = getRetailerInformation(props.orderOptions);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "repeat-m" },
            React.createElement("div", { "data-ecom-productcard": "" },
                React.createElement("div", { className: "product-card-image-content" },
                    React.createElement("div", { className: "prodcut-card-image-section" },
                        React.createElement("div", { className: "product-card-image", style: {
                                backgroundImage: `url(${props.vehicle.imageUrl})`,
                            } })),
                    React.createElement("div", { className: "product-card-content" },
                        React.createElement("div", { className: "product-card-retailer" }, retailerInformation.name),
                        React.createElement("div", { className: "product-card-title" },
                            React.createElement("div", { className: "product-card-heading" }, props.vehicle.title),
                            React.createElement("div", { className: "product-card-sub-heading" }, props.vehicle.shortDescription)),
                        React.createElement("div", { className: "product-card-price" },
                            formattedPrice,
                            " kr"),
                        React.createElement("ul", { className: "product-card-usp-list" },
                            props.vehicle.modelYear && (React.createElement("li", { className: "product-card-usp-item" }, props.vehicle.modelYear)),
                            props.vehicle.milage && (React.createElement("li", { className: "product-card-usp-item" }, props.vehicle.milage)),
                            props.vehicle.gearBox && (React.createElement("li", { className: "product-card-usp-item" }, props.vehicle.gearBox)),
                            props.vehicle.fuelType && (React.createElement("li", { className: "product-card-usp-item" }, props.vehicle.fuelType))))),
                items)),
        React.createElement(DeliveryInformation, Object.assign({}, props)),
        tradeInItem));
};
